import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

/*
For improvements add file.fileType checks
Hindi ko lang nasama dito kasi nung fi-netch yung files hindi ko nasama sa fields
yung file type, kaya diko na chineck dito
*/

const FilePreviewUser = ({ open, onClose, file }) => {
  if (!file) {
    return null;
  }

  const fileName = file.fileName;
  const downloadURL = file.downloadURL;
  const fileType = file.fileType;

  const isPdf = fileType.toLowerCase().startsWith("application/pdf");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Preview: {fileName}</DialogTitle>

      <DialogContent dividers>
        {downloadURL ? (
          <Box
            component={isPdf ? "embed" : "img"}
            src={downloadURL}
            alt={fileName}
            sx={{
              width: "100%",
              height: isPdf ? "80vh" : "auto",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        ) : (
          <Typography variant="body1" color="textDanger" textAlign={"center"}>
            Preview not available for this file type.<br></br> Download URL
            might be expired.
          </Typography>
        )}
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Summary
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {file.summary && file.summary.trim() !== ""
              ? file.summary
              : "Summary is not available."}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilePreviewUser;
